module.exports = {
    trackMyOrder: {
        deliveryEtaDisclaimer: '*Please note the estimated time of delivery is an indicative time of when the driver will arrive, your order may still arrive any time within the delivery window you selected. The estimated time of arrival may change due to traffic conditions and other reasons outside Woolworths Online control.',
        deliveryMessage:
            "We'll let you know the estimated time of delivery for your order soon. Generally this is available the day of delivery, or after the cut off time for same day orders (where available).",
        dispatchedText: 'Order due today',
        pickupMessage: 'We\'ll send you an SMS when your order is ready to pick up.',
        pickupMessageWithEmailInfo: 'We\'ll send you an email (and SMS if we have your mobile number) when your order is ready to pick up.',
        expressDeliveryMessage: 'We\'ll send you an SMS when your Delivery Now order is on it\'s way.',
        placedText: 'Order placed',
        readyText: 'Order ready',

        deliveryLocationLabel: 'Delivery location',
        pickupLocationLabel: 'Pick up location',

        deliveryWindowLabel: 'Delivery Order Details',
        pickupWindowLabel: 'Pick Up Order Details',
        expressDeliveryWindowLabel: 'Your order will be delivered',

        tradingHoursLabel: 'Trading hours',
        noOrdersMessage: 'No active orders to track',

        // track my order tips and directions.
        trackYourOrderText: 'We\'ll send you an SMS from the mobile number 0400 400 400 with your estimated delivery time and driver\'s contact number.',
        deliveryTips: `
        <h3>Helpful tips for delivery:</h3>
        <ul style="list-style: initial; margin-left: 20px">
            <li>Leave a light on for your driver if your delivery is after dark.</li>
            <li>Secure any pets that may limit access for your driver.</li>
        </ul>
        `,
        pickupTips: `
        <h3>Pick up is easy:</h3>
        <ol style="list-style: decimal; margin-left: 20px">
            <li>Simply go to the Pick up point in store.</li>
            <li>Present your photo ID and Order Number to a Woolworths team member.</li>
            <li>Take home your groceries.</li>
        </ol>
        <h3>Tips for faster Pick up:</h3>
        <p>
            <a href="/Shop/Discover/about-us/woolworths-app">
            Download our mobile app</a> and we'll send you a notification when your order is ready. Plus you can tell us when you're
            close by, so that we can have everything ready for your arrival.
        </p>
        `,
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/track-my-order.js